export function preventEventDefault(event: Event) {
  if (event.preventDefault) {
    // modern browsers
    event.preventDefault()
  }
}
